import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalWrapper, Content, ContentTheme } from './styled';

export const ContextModalWidth = 203;
export const CONTEXT_MODAL_AUTO_WIDTH = 'auto';

const ContextModal = (props) => {
  const [modalBottom, setModalBottom] = useState(0);

  useEffect(() => {
    if (innerHeight - props.positionY < 150) {
      setModalBottom(innerHeight - props.positionY);
    }
  }, [props.positionY]);

  return (
    props.show && (
      <ModalWrapper
        data-testid="context-modal"
        positionArrow={props.positionArrow}
        positionX={props.positionX}
        positionY={props.positionY}
        positionArrowReverse={props.flowUp}
        modalWidth={props.modalWidth}
        modalBottom={modalBottom}
        contextTheme={props.contextTheme}
        leftAlign={props.leftAlign}
        positionArrowY={props.positionArrowY}
        transform={props.positionArrowY}
      >
        {props.contextTheme ? (
          <ContentTheme>{props.children || props.name}</ContentTheme>
        ) : (
          <Content>{props.children}</Content>
        )}
      </ModalWrapper>
    )
  );
};

ContextModal.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
  flowUp: PropTypes.bool,
  positionX: PropTypes.number,
  positionY: PropTypes.number,
  positionArrow: PropTypes.number,
  contextTheme: PropTypes.string,
  name: PropTypes.string,
  positionArrowY: PropTypes.number,
  leftAlign: PropTypes.bool,
  modalWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([CONTEXT_MODAL_AUTO_WIDTH])
  ])
};

ContextModal.defaultProps = {
  modalWidth: ContextModalWidth
};

export default ContextModal;



// WEBPACK FOOTER //
// ./components/context-modal/index.js